"use client";

import { cn } from "utils";
import { memo } from "react";
import { PriceDisplayClassNames } from "./types";
import PriceDisplay from ".";
import { useFormatPrice } from "@/src/hooks/useTokenPopoverData/useFormatPrice";

interface FormattedPriceProps {
  /**
   * 原始价格值（字符串或数字）
   */
  price: string;
  /**
   * 自定义类名
   */
  className?: PriceDisplayClassNames;

  type?: "token" | "stock" | "others";

  // 货币符号
  currencySymbol?: string;

  hideUnitSymbol?: boolean;
}

/**
 * 通用价格显示组件
 * 支持零压缩显示和千分位格式化
 *
 * @example
 * ```tsx
 * <FormattedPrice price="1234.567890" />
 * // 显示: $1,234.567890
 *
 * <FormattedPrice price="0.00001234" />
 * // 显示: $0.0₄1234
 *
 * <FormattedPrice price={null} />
 * // 显示: --
 * ```
 */
export const FormattedPrice = memo<FormattedPriceProps>(
  ({ price, className, type, currencySymbol = "$", hideUnitSymbol }) => {
    const { priceData } = useFormatPrice({ price, type: type || "token" });
    return (
      <PriceDisplay
        currencySymbol={currencySymbol}
        priceData={priceData}
        hideUnitSymbol={hideUnitSymbol}
        classNames={{
          container: cn(
            "headline_regular_m text-content_primary",
            className?.container,
          ),
          zeroCount: cn("body_medium_s", className?.zeroCount),
        }}
      />
    );
  },
);

FormattedPrice.displayName = "FormattedPrice";
